import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { ObjectCache } from '../Models/objectCache.model';
import { Observable } from 'rxjs';
import { ProviderCategory } from '../categories/category';
import { PreferencesService } from './preferences.service';

@Injectable({
  providedIn: 'root',
})
export class ProviderCategoryService extends DataService<ProviderCategory> {
  constructor(private db: AngularFireDatabase, private ps: PreferencesService) {
    super(db, `entities/${ps.getLocationCode()}/Data/en/ProviderCategories`, new ObjectCache<ProviderCategory>());
  }

  getCachedCategories(lang?: string): ProviderCategory[] {
    return super.getCachedObjects(lang);
  }

  getCategoryById(id: string, lang?: string): Observable<ProviderCategory> {
    return super.getObjectById(id, lang);
  }

  getUpdatableCategories(lang?: string): AngularFireList<ProviderCategory> {
    return super.getAngularFireObjects(lang);
  }

  async getSingleCategory(id: string, lang?: string): Promise<ProviderCategory> {
    let path = this.PATH + '/' + id;
    if (lang) {
      path = path.replace('/en/', `/${lang}/`);
    }
    const result = await super.getRawDataFromPath(path);
    let results: ProviderCategory;
    results = result;
    return results;
  }

  async findCategory(id: string, lang?: string): Promise<ProviderCategory> {
    return await super.findDocument(id, lang);
  }

  async findCategories(lang?: string): Promise<ProviderCategory[]> {
    return await super.findCollection(lang);
  }
}
